module.exports = __webpack_public_path__ + "img/azvi-simple-logo.229fe573.jpeg";